




import { Component, Vue, Prop } from "vue-property-decorator";
import { UrlResult } from "@/domainproject/controller";
@Component({
  watch: {
    urlResult: function(this: Scorer) {
      this.updateCanvas();
    },
    height: function(this: Scorer) {
      this.updateCanvas();
    }
  }
})
export default class Scorer extends Vue {
  @Prop() width!: number;
  @Prop() height!: number;
  @Prop() minScore!: number;
  @Prop() maxScore!: number;
  @Prop() urlResult!: UrlResult;

  mounted() {
    this.updateCanvas();
  }

  get canvas(): HTMLCanvasElement {
    return this.$refs["canvas"] as HTMLCanvasElement;
  }

  get numFilters(): number {
    return this.urlResult.$_filters.length;
  }

  get rowHeight(): number {
    return this.height / this.numFilters;
  }

  get scoreWidth(): number {
    return this.maxScore - this.minScore;
  }

  updateCanvas() {
    const ctx = this.canvas.getContext("2d")!;
    ctx.clearRect(0, 0, this.width, this.height);

    const origin = (this.width * -this.minScore) / this.scoreWidth;

    ctx.lineWidth = 0;
    for (let i = 0; i < this.numFilters; i++) {
      const filter = this.urlResult.$_filters[i];
      if (filter.$_score == null) continue;
      const y1 = this.rowHeight * (i + 0.1);
      const x2 =
        (this.width * (filter.$_score - this.minScore)) / this.scoreWidth;
      ctx.fillStyle = filter.$_filter.$_color.$_hex;
      if (x2 > origin) {
        ctx.fillRect(
          origin,
          y1,
          x2 - origin,
          this.rowHeight - this.rowHeight * 0.2
        );
      } else {
        ctx.fillRect(
          x2,
          y1,
          origin - x2,
          this.rowHeight - this.rowHeight * 0.2
        );
      }
    }

    if (origin >= 0) {
      ctx.beginPath();
      ctx.strokeStyle = "white";
      ctx.lineWidth = 2;
      ctx.moveTo(origin, 0);
      ctx.lineTo(origin, this.height);
      ctx.stroke();
    }
  }
}
